import { FC } from 'react';

interface IBlogJsonMarkup {
  title: string;
  description: string;
  seoTitle: string;
}

const BlogJsonMarkup: FC<IBlogJsonMarkup> = ({ title, description, seoTitle }) => {
  const getBookJsonMarkup = () => {
    return {
      __html: `
      { " @context": "https://schema.org","@type": "Article","name":"${title}","description":"${description}","about": {"@type": "Thing","name": "${seoTitle}"}}`,
    };
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={getBookJsonMarkup()} key="product-jsonld" />;
};

export default BlogJsonMarkup;
